import { useTranslation } from 'react-i18next';
import SectionHead from '../shared/SectionHead';
import { useReveal } from '../../hooks/useReveal';

const STEP_IMGS = [
  '/assets/pixviewer_gaps_overview.png',
  '/assets/linhas.png',
  '/assets/falhas.png',
  '/assets/relatorio.png',
];

function StepMeta({ n, s }) {
  return (
    <div style={{ padding: '48px 40px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
      <div className="mono" style={{ fontSize: 44, color: 'var(--p2a-green-400)', fontWeight: 600, letterSpacing: '-0.03em', lineHeight: 1 }}>
        {n}
      </div>
      <h3 className="h-2" style={{ marginTop: 12, marginBottom: 12 }}>{s.t}</h3>
      <p style={{ fontSize: 15.5, lineHeight: 1.55, color: 'var(--p2a-dark-fg-2)' }}>{s.d}</p>
      <div style={{ marginTop: 24, display: 'flex', flexWrap: 'wrap', gap: 6 }}>
        {s.tags.map((tag) => (
          <span key={tag} className="mono" style={{
            fontSize: 11, padding: '3px 10px',
            border: '1px solid var(--p2a-dark-border-2)',
            borderRadius: 999, color: 'var(--p2a-dark-fg-3)',
          }}>{tag}</span>
        ))}
      </div>
    </div>
  );
}

export default function PRPipeline() {
  const { t } = useTranslation();
  const ref = useReveal({ stagger: 0.1 });
  const steps = t('pr.pipeline.steps', { returnObjects: true });

  return (
    <section
      ref={ref}
      id="pipeline"
      className="section"
      style={{ background: 'var(--p2a-dark-bg)', borderBottom: '1px solid var(--p2a-dark-border)' }}
    >
      <div className="p2-container">
        <SectionHead
          eyebrow={t('pr.pipeline.eyebrow')}
          title={t('pr.pipeline.title')}
          lede={t('pr.pipeline.lede')}
          max={640}
        />

        <div style={{ marginTop: 48, display: 'flex', flexDirection: 'column', gap: 0, borderTop: '1px solid var(--p2a-dark-border)' }}>
          {steps.map((s, i) => {
            const n = String(i + 1).padStart(2, '0');
            const img = STEP_IMGS[i];
            return (
              <div
                key={i}
                className="reveal pr-step"
                style={{
                  display: 'grid',
                  gridTemplateColumns: i % 2 ? '1fr 1.4fr' : '1.4fr 1fr',
                  borderBottom: '1px solid var(--p2a-dark-border)',
                  minHeight: 320,
                }}
              >
                {i % 2 === 0 ? (
                  <>
                    <div style={{ position: 'relative', background: `url("${img}") center/cover` }}>
                      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(90deg, rgba(5,7,10,0) 40%, rgba(5,7,10,0.75))' }} />
                    </div>
                    <StepMeta n={n} s={s} />
                  </>
                ) : (
                  <>
                    <StepMeta n={n} s={s} />
                    <div style={{ position: 'relative', background: `url("${img}") center/cover` }}>
                      <div style={{ position: 'absolute', inset: 0, background: 'linear-gradient(-90deg, rgba(5,7,10,0) 40%, rgba(5,7,10,0.75))' }} />
                    </div>
                  </>
                )}
              </div>
            );
          })}
        </div>
      </div>
      <style>{`
        @media (max-width: 820px) {
          .pr-step { grid-template-columns: 1fr !important; }
          .pr-step > div:first-child { min-height: 220px; }
        }
      `}</style>
    </section>
  );
}
